import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const styles = theme => ({
  root: {},
  browserNotSupported: {},
  browserNotSupportedCenter: {
    width: 84,
    margin: '0 auto',
    marginTop: 100,
    textAlign: 'center'
  }
})

class Preview extends React.Component {
  render () {
    const { classes, printBlobURL } = this.props

    if (!printBlobURL || printBlobURL === '') {
      return null
    }

    // Same as PDFViewer component, but allows us to use the blob url directly.
    return (
      <iframe
        src={printBlobURL}
        className={classes.pdf}
        title={'reactpdfprintpreview'}
        id={'reactpdfprintpreview'}
        type="application/pdf"
        width="100%"
        height="100%"
        frameBorder="0"
        /* allowFullScreen="allowfullscreen"
        mozallowfullscreen="mozallowfullscreen"
        msallowfullscreen="msallowfullscreen"
        oallowfullscreen="oallowfullscreen"
        webkitallowfullscreen="webkitallowfullscreen" */
      />
    )
  }
}

Preview.propTypes = {
  classes: PropTypes.object.isRequired,
  printBlobURL: PropTypes.string.isRequired,
  printSize: PropTypes.string.isRequired,
  printOrientation: PropTypes.string.isRequired
}

function mapStateToProps (state, ownProps) {
  return {
    printBlobURL: state.printBlobURL,
    printSize: state.printSize,
    printOrientation: state.printOrientation
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Preview)
  )
)
